import { render, staticRenderFns } from "./BeforeAnalysis.vue?vue&type=template&id=2ff4c1dc&scoped=true&"
import script from "./BeforeAnalysis.vue?vue&type=script&lang=ts&"
export * from "./BeforeAnalysis.vue?vue&type=script&lang=ts&"
import style0 from "./BeforeAnalysis.vue?vue&type=style&index=0&id=2ff4c1dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff4c1dc",
  null
  
)

export default component.exports